/**
 * Product page initialization
 * Tracks viewed products in session storage when product page loads
 */

import { updateViewedProducts } from '@/components/helpers/product'

function handleProductLoad() {
  if (typeof window.productSku === 'undefined') return
  updateViewedProducts(window.productSku)
}

handleProductLoad()
